<template>
    <div class="records">
        <h2>
            Records
        </h2>
        <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin"></i>
        </span>
        <div v-else-if="!records.length">
            No hay registro de votos aún
        </div>
        <v-data-table
            :headers="headers"
            :items="votos"
            :items-per-page="5"
            :search="search"
            class="records-table"
            multi-sort
        ></v-data-table>
    </div>
</template>

<script>
import VTable from '@/components/common/Table';
import { DateTime } from 'luxon';

export default {
    components: {
        VTable,
    },
    data() {
        return {
            search: '',
            isLoading: false,
            records: [],
            headers: [
                { text: 'Eleccion id', value: 'eleccion_id', sortable: true },
                { text: 'Id mesa', value: 'id_mesa', sortable: true },
                { text: 'Id planilla', value: 'id_planilla', sortable: true },
                { text: 'OCG', value: 'ocg', sortable: true },
                { text: 'Creado', value: 'created_at', sortable: true },
            ],
        };
    },
    computed: {
        votos() {
            return this.records.map(record => {
                record.created_at = DateTime.fromISO(
                    record.created_at
                ).toLocaleString(DateTime.DATETIME_SHORT);
                return record;
            });
        },
    },
    methods: {
        requestData() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.$store
                .dispatch('elecciones/getRecords')
                .then(res => {
                    this.records = _.get(res, 'votes_records') || [];
                })
                .catch(error => {
                    console.log('ERROR');
                    console.error(error);
                    this.records = [];
                    this.$store.dispatch('errorMessage', `${error}`);
                })
                .finally(_ => (this.isLoading = false));
        },
    },
    created() {
        this.requestData();
    },
};
</script>

<style lang="scss" scoped>
.records {
    padding: 10px;
}
</style>
